const convertUsersForNotificationsScreen = (users, selectedUsers) => users.map((user) => ({
  name: user.preferredName,
  number: user.ids.unit,
  checked: !!(selectedUsers.find((selectedUser) => user.ids.unit === selectedUser.number)),
}))

export default convertUsersForNotificationsScreen
